<!-- eslint-disable max-lines -->
<template>
    <div>
        <el-dialog
            v-dialogDrag
            class="form-dialogs supplierDialog"
            title="排车调度"
            :visible.sync="controlVisiable"
            :before-close="cancelControl"
            width="80%"
        >
            <el-form
                :label-position="labelPosition"
                :model="AdmittRuleForm"
                :rules="controlRules"
                label-width="120px"
                ref="AdmittRuleForm"
                class="row-box"
            >
                <el-row :gutter="2">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item
                                label="承运商"
                                prop="carrierName"
                                class="label-form"
                            >
                                <otpAdvance
                                    :title="AdmittRuleForm.carrierName"
                                    :formData="AdmittRuleForm"
                                    :prop="'carrierName'"
                                    :mValue="AdmittRuleForm.carrierName"
                                    :params="customerOrderNoCode"
                                    :disabled="isdisabled"
                                    @getAdvanceValue=" getAdvanceValue($event, 'carrierName')"
                                >
                                </otpAdvance>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item
                                label="采购渠道"
                                prop="procurementChannel"
                                class="label-form"
                            >
                                <el-select
                                    v-if="dataLists.procurementChannel !== '00' && !dataLists.procurementChannel"            v-model="AdmittRuleForm.procurementChannel"
                                    placeholder="请选择采购渠道" @change="procurementChannelChange">
                                    <el-option
                                        v-for="item in procurementChannelOptions"
                                        :key="item.transName"
                                        :label="item.transName"
                                        :value="item.transType">
                                    </el-option>
                                </el-select>
                                <selects
                                    v-else
                                    :disabled="true"
                                    :mValue="AdmittRuleForm.procurementChannel"
                                    :optionNum="'OTP_TMS_PROCUREMENT_CHANNEL'"
                                    :prop="'procurementChannel'"
                                    @getSelectValue="getAdvanceValue"
                                ></selects>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item
                                label="车牌"
                                prop="vehicleCard"
                                class="label-form"
                                :rules="[{required: driverPropCheck, message: '车牌不能为空', trigger: 'change' }]"
                                v-model="AdmittRuleForm.vehicleCard"
                            >
                                <otpAdvance
                                    :formData="AdmittRuleForm"
                                    :mValue="AdmittRuleForm.vehicleCard"
                                    :prop="'vehicleCard'"
                                    :disabled="AdmittRuleForm.isExpressCarrier === 'Y' && +AdmittRuleForm.shippingType === 4"
                                    @getAdvanceValue="
                                        getAdvanceValue($event, 'vehicleCard')
                                    "
                                    :params="vehicleCardLists"
                                >
                                </otpAdvance>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item
                                label="计费车型"
                                prop="equipmentName"
                                class="label-form"
                            >
                                <el-input
                                    clearable
                                    :disabled="true"
                                    v-model.trim="AdmittRuleForm.equipmentName"
                                    size="medium"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item
                            label="司机"
                            prop="driver"
                            class="label-form"
                            :rules="[{ required: driverPropCheck, message: '司机不能为空', trigger: 'change' }]"
                            v-model="AdmittRuleForm.driver"
                        >
                            <otpAdvance
                                :formData="AdmittRuleForm"
                                :mValue="AdmittRuleForm.driver"
                                :prop="'driver'"
                                :disabled="AdmittRuleForm.isExpressCarrier === 'Y' && +AdmittRuleForm.shippingType === 4"
                                @getAdvanceValue="
                                    getAdvanceValue($event, 'driver')
                                "
                                :params="driverLists"
                            >
                            </otpAdvance>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item
                            label="电话"
                            prop="driverContactWay"
                            class="label-form"
                        >
                            <el-input
                                clearable
                                :disabled="true"
                                v-model.trim="AdmittRuleForm.driverContactWay"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6" v-if="['10', '190'].includes(siteType)">
                    <div class="grid-content bg-purple">
                        <el-form-item label="设备号" class="label-form">
                            <el-input
                                :disabled="true"
                                v-model.trim="AdmittRuleForm.deviceNo"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6"  v-if="intranetInformationFlag">
                    <el-form-item
                        label="在途联系类别"
                        prop="onWayContactCategory"
                        class="label-form"
                    >
                        <el-select
                            v-model="AdmittRuleForm.onWayContactCategory"
                            :disabled="informationFlag"
                            style="width: 100%"
                            placeholder="请选择在途联系类别"
                            @change="onWayContactCategoryChange"
                        >
                            <el-option
                                v-for="item in onWayContactCategoryList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6"  v-if="intranetInformationFlag">
                    <el-form-item
                        label="在途联系人"
                        prop="onWayContactName"
                        class="label-form"
                    >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        v-if="onWayContactFlag"
                        :prop="'onWayContactName'"
                        :disableSearch="true"
                        class="otpAdvance-onWayContactName"
                        :mValue="AdmittRuleForm.onWayContactName"
                        :params="onWayContactNameParams"
                        @getAdvanceValue="getOnWayContactValue"
                    ></otpAdvance>
                        <el-input
                            v-else
                            clearable
                            :disabled="informationFlag"
                            v-model.trim="AdmittRuleForm.onWayContactName"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6"  v-if="intranetInformationFlag">
                    <el-form-item
                        label="在途联系人电话"
                        prop="onWayContactPhone"
                        class="label-form"
                    >
                        <el-input
                            clearable
                            :disabled="informationFlag || onWayContactFlag"
                            v-model.trim="AdmittRuleForm.onWayContactPhone"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-if="AdmittRuleForm.procurementChannel && whiteListCheck()">
                    <el-form-item
                        class="label-form"
                        label="发运类型"
                        prop="shippingType"
                    >
                        <selects
                            :optionNum="'TMS_SHIPPING_TYPE'"
                            :mValue="AdmittRuleForm.shippingType"
                            @getSelectValue="getAdvanceValue"
                            placeholder="请选择发运类型"
                            :prop="'shippingType'"
                        ></selects>
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-if="AdmittRuleForm.isExpressCarrier === 'Y' && +AdmittRuleForm.shippingType === 4">
                    <el-form-item
                        key="multiPackagesShipment "
                        label="是否拆子母件"
                        prop="multiPackagesShipment"
                        class="label-form"
                    >
                        <el-select
                            v-model="AdmittRuleForm.multiPackagesShipment "
                            placeholder="请选择是否是否拆子母件"
                        >
                            <el-option label="是" value="Y" ></el-option>
                            <el-option label="否" value="N" ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-if="this.siteType === '20' || this.siteType === '40'">
                    <el-form-item
                    class="label-form">
                        <el-checkbox disabled v-model="AdmittRuleForm.forceChuanDian" :true-label="1" :false-label="0">直控线路串点计费模式</el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-if="AdmittRuleForm.shippingType === '0'">
                    <el-form-item
                        label="是否直通宝转运"
                        prop="ztbTransportFlag"
                        class="label-form"
                    >
                        <el-select
                            v-model="AdmittRuleForm.ztbTransportFlag"
                            placeholder="请选择是否直通宝转运"
                        >
                            <el-option
                                v-for="item in ztbTransportFlagList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- 备注 -->
                <el-col :span="6">
                    <el-form-item class="label-form" label="备注" prop="remark">
                        <el-input
                        type="textarea"
                        placeholder="请输入"
                        v-model="AdmittRuleForm.remark"
                        maxlength="50"
                        show-word-limit
                        clearable
                        >
                    </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-if="AdmittRuleForm.procurementChannel">
                    <el-form-item
                        class="label-form"
                        key="actualEquipmentName"
                        label="实际运作车型">
                        <el-input
                            v-model="AdmittRuleForm.equipmentName"
                            size="medium"
                            clearable
                            disabled/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="AdmittRuleForm.procurementChannel">
                    <el-form-item
                        key="scheduleVehicleRequirement"
                        style="width: 100%"
                        label="车型排车考核要求">
                        <span style="color: #FF4949">{{ scheduleVehicleRequirement }}</span>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class>
                <el-button @click="cancelControl">取 消</el-button>
                <el-button
                    type="primary"
                    @click="addOkControl('AdmittRuleForm')"
                    >确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import otpAdvance from '@/components/lots/otpAdvance';
import request from '@/utils/http';
import selects from '@/components/lots/otpSelect';
import { getSearchBySupplier, getWhitelistList, getIsControlTransportToOpt, getProcurementChannelListApi, judgeExpressApi, isLingDanApi } from '../../api/carSchedulingDialog';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: { otpAdvance, selects },
    props: {
        labelPosition: {
            type: String,
            default: 'right'
        },
        controlVisiable: {
            type: Boolean,
            default: false
        },
        dataLists: {
            type: Object,
            default () {
                return {};
            }
        },
        taskDataList: {
            type: Array,
            default () {
                return [];
            }
        },
        disableEdit: { // 是否开启承运商、车牌、司机的可编辑模式
            type: Boolean,
            default: false
        },
        isPlanArrange: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            isdisabled: true,
            customerOrderNoCode: {
                'name': '请输入承运商',
                'advanceLabel': '承运商',
                'value': 'carrierName',
                'advanceConfig': [
                    { 'prop': 'supplierNameCn', 'value': '承运商名称' },
                    { 'prop': 'supplierCode', 'value': '承运商编码' }
                ],
                'tableConfig': [
                    { 'prop': 'supplierNameCn', 'value': '承运商名称' },
                    { 'prop': 'supplierCode', 'value': '承运商编码' },
                    { 'prop': 'transNameListStr', 'value': '采购渠道' }
                ],
                advanceNotSearch: true,
                queryConditionRequired: true,
                method: 'post',
                advanceUrl: 'srm/supplier/search',
                prefix: '/api-tms/',
                'cbParams': [
                    'supplierNameCn#carrierName', 'supplierNameCn#supplierCode', 'transTypeListStr#transType', 'transNameListStr#tranName', 'supplierNameCn#carrierCode'
                ],
                'advanceCascade': 'professionalCompanyList,siteCodeList,procurementChannel#transType'
            },
            // 车牌
            vehicleCardLists: {
                method: 'post',
                name: '请输入车牌号',
                advanceLabel: '车牌号',
                value: 'vehicleCard',
                advanceConfig: [
                    { prop: 'licensePlateNo', value: '车牌' }
                ],
                tableConfig: [
                    { prop: 'licensePlateNo', value: '车牌' },
                    { prop: 'maxVolume', value: '载货体积' },
                    { prop: 'carTypeNameCn', value: '车型' },
                    { prop: 'carType', value: '车型编码' }
                ],
                cbParams: ['licensePlateNo#vehicleCard', 'maxVolume#cargoVolumeStr', 'carTypeNameCn#equipmentName', 'carType#equipmentType', 'deviceNo'],
                prefix: '/api-tms/',
                advanceUrl: '/dispatch/resource/car/query',
                advanceCascade: 'supplierCode,siteCodeList,checkResource'
            },
            // 司机
            driverLists: {
                method: 'post',
                name: '请输入司机',
                advanceLabel: '司机',
                value: 'driver',
                advanceConfig: [
                    { prop: 'driverName', value: '司机' },
                    { prop: 'driverPhone', value: '电话' },
                    { prop: 'driverCode', value: 'DN编码' },
                    { prop: 'driverIdCard', value: '身份证号' }
                ],
                tableConfig: [
                    { prop: 'driverName', value: '司机' },
                    { prop: 'driverPhone', value: '电话' },
                    { prop: 'driverCode', value: 'DN编码' },
                    { prop: 'driverIdCard', value: '身份证号' }
                ],
                prefix: '/api-tms/',
                advanceUrl: 'dispatch/resource/driver/query',
                cbParams: ['driverName#driver', 'driverPhone#driverContactWay', 'driverIdCard#driverIdentity', 'onWayContactCategory', 'onWayContactName', 'onWayContactPhone', 'driverCode#driverNo'],
                advanceCascade: 'supplierCode,siteCodeList,checkResource'
            },
            // 在途联系人
            onWayContactNameParams: {
                method: 'post',
                name: '请输入在途联系人',
                advanceLabel: '在途联系人',
                value: 'contacts',
                rule: {
                    validate: (formData) => {
                        return new Promise((resolve, reject) => {
                            const url = '/api-tms/srm/onWayContact/queryPage';
                            request({
                                url,
                                method: 'post',
                                data: {
                                    supplierCode: formData.supplierCode,
                                    pageNo: '1',
                                    pageSize: '10'
                                }
                            }).then(res => {
                                if (res.data.list.length > 0) {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            });
                        });
                    },
                    message: '请到LSRM-供应商主数据（联系人信息）维护对应信息，或者将“在途联系人类别”切换为司机”',
                    async: true
                },
                advanceConfig: [
                    { prop: 'contacts', value: '在途联系人' },
                    { prop: 'contactsMobile', value: '电话' }
                ],
                tableConfig: [
                    { prop: 'contacts', value: '在途联系人' },
                    { prop: 'contactsMobile', value: '电话' }
                ],
                prefix: '/api-tms/',
                advanceUrl: 'srm/onWayContact/queryPage',
                cbParams: ['contacts', 'contactsMobile#onWayContactPhone'],
                advanceCascade: 'supplierCode,checkResource'
            },
            AdmittRuleForm: {
                supplierCode: '',
                routeNoList: [],
                vehicleCard: '',
                driver: '',
                driverIdentity: '',
                equipmentType: '',
                deviceNo: '',
                forceChuanDian: 0,
                checkResource: false,
                shippingType: '',
                ztbTransportFlag: 1,
                remark: '',
                directlyControlledRecord: {
                    reasonDialogVisible: false,
                    directControlTransportCapacityFlag: false
                },
                supplierStatus: '30',
                businessTypeStatus: '5',
                isExpressCarrier: '', // 是否快递公司
                expressCompanyCode: '', // 快递公司编码
                expressCompanyName: '', // 快递公司名称
                multiPackagesShipment: 'N'
                // exceptionType: "",
                // exceptionMark:"",
            },
            siteType: '',
            controlRules: {
                vehicleCard: [
                    {
                        required: true,
                        message: '车牌不能为空',
                        trigger: 'blur'
                    }
                ],
                driver: [
                    {
                        required: true,
                        message: '司机不能为空',
                        trigger: 'blur'
                    }
                ],
                onWayContactName: [
                    {
                        required: true,
                        message: '请输入在途联系人',
                        trigger: 'blur'
                    },
                    { max: 10, message: '长度在10个字符', trigger: 'blur' }
                ],
                onWayContactPhone: [
                    {
                        required: true,
                        message: '请输入在途联系人电话',
                        trigger: 'blur'
                    },
                    { pattern: /^1[3-9](\d{9})$/, message: '请输入正确的手机号', trigger: ['change'] },
                    { max: 11, message: '请输入11位手机号', trigger: 'change' }
                ],
                shippingType: [
                    {
                        required: true,
                        message: '发运类型不能为空',
                        trigger: ['change']
                    }
                ],
                ztbTransportFlag: [
                    { required: true, message: '请选择是否直通宝转运', trigger: 'change' }
                ],
                multiPackagesShipment: [
                    {
                        required: true,
                        message: '是否拆子母件不能为空',
                        trigger: ['change']
                    }
                ],
            },
            onWayContactCategoryList: [ // 在途联系类别
                {
                    value: '1',
                    label: '司机'
                }, {
                    value: '2',
                    label: '供应商'
                }
            ],
            ztbTransportFlagList: [
                { value: 1, label: '是' },
                { value: 0, label: '否' }
            ],
            intranetInformationFlag: false,
            informationFlag: false,
            formBusinessType: '',
            dictData: {}, // 字典数据
            procurementChannelOptions: []// 采购渠道集合
        };
    },
    methods: {
        async getAdvanceValue (data, prop) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            if (prop === 'driver') {
                this.AdmittRuleForm.onWayContactCategory = data.onWayContactCategory ? data.onWayContactCategory : '';
                this.AdmittRuleForm.onWayContactName = data.onWayContactName ? data.onWayContactName : '';
                this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone ? data.onWayContactPhone : '';
                this.informationFlag = false;
                if (!data.onWayContactCategory && !data.onWayContactName && !data.onWayContactPhone) {
                    this.setInformationEntry(this.AdmittRuleForm.propertyNature);
                } else {
                    // 是否手填/新在途联系人
                    this.AdmittRuleForm.newOnWayContact = false;
                    this.intranetInformationFlag = true;
                    this.informationFlag = true;
                }
            }
            if (prop === 'carrierName') {
                // 快递承运商校验
                if (!this.disableEdit && !this.isPlanArrange) { // 网络调车排车、计划排车不需要调这个接口
                    await this.getJudgeExpress();
                }
            }
        },
        // 获取快递公司标识
        async getJudgeExpress () {
            this.AdmittRuleForm.isExpressCarrier = '';
            const params = {
                carrierCode: this.AdmittRuleForm.carrierCode,
                carrierName: this.AdmittRuleForm.carrierName,
                transportList: this.taskDataList
            };
            await judgeExpressApi(params).then(res => {
                if (res && +res.code === 0) {
                    ['isExpressCarrier', 'expressCompanyCode', 'expressCompanyName'].forEach(key => {
                        this.AdmittRuleForm[key] = res.data[key] || '';
                    });
                }
            });
        },
        // 司机在途信息录入->当前运输单的服务平台是否存在于白名单->如果存在于白名单并且承运商主体是法人->将司机在途信息带入
        setInformationEntry (propertyNature) {
            getWhitelistList().then(res => {
                if (this.AdmittRuleForm.siteCode) {
                    this.intranetInformationFlag = res.data.includes(this.AdmittRuleForm.siteCode);
                    if (this.intranetInformationFlag) {
                        if (propertyNature === 1) {
                            // 是否手填/新在途联系人
                            this.AdmittRuleForm.newOnWayContact = true;
                        }

                    }
                }
            });
        },
        async isLingDan () {
            const params = {
                taskNos: this.taskDataList.map(v => v.taskNo),
                carrierCode: this.AdmittRuleForm.carrierCode,
                carrierName: this.AdmittRuleForm.carrierName,
                procurementChannel: this.AdmittRuleForm.procurementChannel
            };
            await isLingDanApi(params).then(res => {
                if (res && +res.code === 0) {
                    this.AdmittRuleForm.shippingType = '';// 清空发运类型
                    if (res.data === 2) {
                        // 当承运商为快递，且零担没打标时，默认发运类型为快递
                        if (this.AdmittRuleForm.isExpressCarrier === 'Y') {
                            this.AdmittRuleForm.shippingType = '4';
                        }
                        return false; // 返回2时，默认为空
                    }
                    this.AdmittRuleForm.shippingType = res.data + '';
                    this.AdmittRuleForm.standardShippingType = res.data + '';
                }
            });
        },
        procurementChannelChange (procurementChannel) {
            // 供方绩效订单卡控需求方案加入参businessType
            this.formBusinessType = '';
            this.procurementChannelOptions.forEach(item => {
                if (item.transType === procurementChannel) {
                    this.formBusinessType = item.businessType || '';
                }
            });
            this.siteType = procurementChannel;
            this.AdmittRuleForm.procurementChannel = procurementChannel;
            // 匹配零担线路配置
            if (this.whiteListCheck()) {
                this.isLingDan();
            }
        },
        async getData (data) {
            ['remark', 'carrierName','carrierCode','siteCode','procurementChannel','vehicleCard','equipmentName','driver','driverContactWay','deviceNo','equipmentType','driverIdentity','onWayContactCategory','onWayContactName','onWayContactPhone','forceChuanDian','dmsFlag','carrierName','transUnitCode','transUnitName','shippingType','ztbTransportFlag','paymentTerms','transportContractNo','multiPackagesShipment','expressNo'].forEach(key => {
               this.AdmittRuleForm[key] = data[key]
            })
            if (typeof data.ztbTransportFlag === 'undefined' ||  data.ztbTransportFlag !== '0') {
                this.AdmittRuleForm.ztbTransportFlag = 1;
            } else {
                this.AdmittRuleForm.ztbTransportFlag =  Number(data.ztbTransportFlag)
            }
            this.AdmittRuleForm.supplierCode = data.carrierCode;
            this.AdmittRuleForm.routeNoList = data.lineCodes;
            this.siteType = data.procurementChannel;
            this.AdmittRuleForm.siteCodeList = this.siteCodeList;
            if (typeof(this.AdmittRuleForm.shippingType) === 'number') {
                this.AdmittRuleForm.shippingType = this.AdmittRuleForm.shippingType + ''
            }
            const { onWayContactCategory, onWayContactName, onWayContactPhone } = this.AdmittRuleForm;
            // 获取承运商主体类型属性
            if (this.AdmittRuleForm.carrierCode) {
                getSearchBySupplier({
                    pageNo: 1,
                    pageSize: 10,
                    supplierCode: this.AdmittRuleForm.carrierCode,
                    siteCodeList: this.siteCodeList,
                    professionalCompanyList: this.professionalCompanyList,
                    supplierStatus: '30',
                    businessTypeStatus: '5'
                }).then(res => {
                    if (res && +res.code === 0 && res.data &&  res.data.list) {
                         this.AdmittRuleForm.propertyNature = res.data.list[0].propertyNature;
                    }
                    if (onWayContactCategory && onWayContactName && onWayContactPhone) {
                        this.AdmittRuleForm.newOnWayContact = false;
                        this.intranetInformationFlag = true;
                        this.informationFlag = true;
                    }
                });
            }
            if (data.procurementChannel !== '00' && !data.procurementChannel) {
                this.getProcurementChannelList(data.carrierCode)
            }
            if (+this.dataLists.originDispatchStatus === 6 && this.AdmittRuleForm.carrierName) {
                this.isLingDan();
            }
            // 快递承运商校验
            if (!this.disableEdit && !this.isPlanArrange) { // 网络调车排车、计划排车不需要调这个接口
                    await this.getJudgeExpress();
                }
        },
        cancelControl () {
            this.$emit('cancelControl', '');
        },
        whiteListCheck () {
            // 判断是否为零担干线公司(3)或零担干线-网络(4)或者城配公司(5)或生产物流(2)
            const updateShippingTypeTaskNos = [];
            this.taskDataList.forEach(item => {
                if ([2, 3, 4, 5].includes(+item.professionalCompany)) {
                    updateShippingTypeTaskNos.push(item.taskNo);
                }
            });
            if (updateShippingTypeTaskNos.length) {
                this.AdmittRuleForm.updateShippingTypeTaskNos = JSON.parse(JSON.stringify(updateShippingTypeTaskNos));
                return true;
            } else {
                return false;
            }
        },
        addOkControl (formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.AdmittRuleForm['procurementChannel'] = this.siteType;
                    if ((this.taskDataList.filter(i => +i.professionalCompany === 5)).length && this.AdmittRuleForm.shippingType === '3') {
                        return this.$message.warning('城配订单时，发运类型不允许选择铁运');
                    }
                    if (this.AdmittRuleForm.shippingType !== '0') {
                            delete this.AdmittRuleForm.ztbTransportFlag;
                    }
                    if ((!this.AdmittRuleForm.vehicleCard || !this.AdmittRuleForm.driver) && this.AdmittRuleForm.isExpressCarrier!== 'Y') {
                            data.preDispatchStrategy = 'CDCHC' //当采购渠道为车队长合车时，司机/车牌没填时，增加标识车队长合车预排标识
                    }
                    if (this.AdmittRuleForm.isExpressCarrier !== 'Y' || +this.AdmittRuleForm.shippingType !== 4) {
                        this.AdmittRuleForm.multiPackagesShipment = 'N';
                    }
                    let AdmittRuleForm = this.AdmittRuleForm
                    let directControlTransportCapacityFlag = false
                    const res = await getIsControlTransportToOpt({ supplierCode: AdmittRuleForm.supplierCode });
                    if (res && +res.code === 0 && +res.data.isControlTransport !== 1) {
                        directControlTransportCapacityFlag = true
                        AdmittRuleForm.directlyControlledRecord.directControlTransportCapacityFlag = false
                    } else {
                        directControlTransportCapacityFlag = false
                        AdmittRuleForm.directlyControlledRecord.directControlTransportCapacityFlag = true
                    }
                    if (this.isDirectControlFlag && directControlTransportCapacityFlag) {
                        AdmittRuleForm.directlyControlledRecord = {
                            firstReasonType: '0',
                            firstReasonValue: '其他',
                            secondReasonType: '0-1',
                            secondReasonValue: '运单已从OTP下发供应商LSP，供应商有变更操作记录，请做好确认及监控！',
                            reasonDialogVisible: true,
                            directControlTransportCapacityFlag: false

                        };
                    }
                    const data = Object.assign({ ntpManagerReverseProcessFlag: false, operateSystem: 'LSP', businessType: this.formBusinessType }, this.AdmittRuleForm);
                    if ((!this.AdmittRuleForm.vehicleCard || !this.AdmittRuleForm.driver) && this.AdmittRuleForm.isExpressCarrier!== 'Y') {
                        data.preDispatchStrategy = 'CDCHC' //当采购渠道为车队长合车时，司机/车牌没填时，增加标识车队长合车预排标识
                    }
                    delete data.supplierCode;
                    delete data.routeNoList;
                    this.$emit('addOkControl', { state: true, data });
                } else {
                    this.$emit('addOkControl', { state: false, form: valid, data: {} });
                    return false;
                }
            });
        },
         // 获取采购渠道
        getProcurementChannelList (supplierCode) {
            const params = {
                supplierCode,
                professionalCompanyList: this.professionalCompanyList
            };
            this.procurementChannelOptions = [];
            getProcurementChannelListApi(params).then(res => {
                if (res && +res.code === 0) {
                    this.procurementChannelOptions = res.data;
                    if (this.procurementChannelOptions.length === 1) { // 只返回一种采购渠道时，直接作为默认值
                        this.procurementChannelChange(this.procurementChannelOptions[0].transType);
                    } else if (this.procurementChannelOptions.length === 2) {
                        this.procurementChannelOptions.forEach(item => {
                            item.transType !== '00' && this.procurementChannelChange(item.transType);
                        });
                    }
                }
            });
        },
        // 可编辑状态下在途联系类别改变
        onWayContactCategoryChange (val) {
            this.AdmittRuleForm.onWayContactName = '';
            this.AdmittRuleForm.onWayContactPhone = '';
            if (val === '1') {
                this.AdmittRuleForm.onWayContactName = this.AdmittRuleForm.driver;
                this.AdmittRuleForm.onWayContactPhone = this.AdmittRuleForm.driverContactWay;
            }
        },

        // 在途联系人基础数据
        getOnWayContactValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm };
            this.AdmittRuleForm.onWayContactName = data.contacts ? data.contacts : '';
            this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone ? data.onWayContactPhone : '';
        },
         async getDictData () {
            const res = await dictWithUrl([
                'SCHEDULE_VEHICLE_REQUIREMENT' // 车型排车考核要求
            ].join(','));
            if (res && +res.code === 0) {
                this.dictData = res.data || {};
            }
        },
    },
    created () {
        this.getData(this.dataLists);
        this.getDictData();
    },
    computed: {
        // 在途联系人是否可选
        onWayContactFlag () {
            if (!this.informationFlag && this.AdmittRuleForm.onWayContactCategory === '2') {
                return true;
            }
            return false;
        },
        siteCodeList () {
            return [...new Set(this.taskDataList.map(i => i.siteCode))];
        },
        isDirectControlFlag () {
            return this.taskDataList.some(i => +i.directControlFlag === 1);
        },
        professionalCompanyList () {
            return this.taskDataList.map(i => i.professionalCompany);
        },
        driverPropCheck () {
            // 采购渠道为车队长合车、车队供应商 || 是快递公司时，司机、车牌非必填,不是快递公司时转移新建都必填
            return ((![40, 42].includes(+this.AdmittRuleForm.procurementChannel) || this.dataLists.carrierName || this.AdmittRuleForm.carRequire) && this.AdmittRuleForm.isExpressCarrier !== 'Y') || (this.AdmittRuleForm.isExpressCarrier === 'Y' && +this.AdmittRuleForm.shippingType !== 4);
        },
        // 车型排车考核要求：内容做成参数配置，上线初始化：“请按真实运作车型排车，如果计费车型错误，发车之后OMS改单修改车型，不允许SRM乱维护车牌号对应的运作车型”
        scheduleVehicleRequirement () {
            const dictObj = this.dictData.SCHEDULE_VEHICLE_REQUIREMENT;
            return dictObj ? dictObj.value : '';
        }
    },
    watch: {
        taskDataList: {
            handler: function (newVal, oldVal) {
                this.AdmittRuleForm.checkResource = false;
                newVal.forEach(i => {
                    if (i.inOutTypeCheck === 'OUT' || i.inOutType === 'YS') {
                        this.AdmittRuleForm.checkResource = true;
                        return false;
                    }
                });
            },
            deep: true,
            immediate: true
        },
    }
};
</script>

<style lang="less">
.supplierDialog .el-input--medium {
    font-size: 12px;
}
.supplierDialog {
    .el-input--medium .el-input__inner {
        height: 28px;
    }
    .otpAdvance-onWayContactName{
        height: 1.9375rem;
    }
    .row-box {
        margin: 0 !important;
    }
    .el-row {
        width: 100%;
        margin: 0 !important;
    }
    .el-col-6 {
        padding: 0 !important;
    }
}
</style>
